// import { LayoutGrid, ShoppingCart, MessageSquare, Calendar } from 'lucide-react';
import { CiUser } from "react-icons/ci";
import { GrUserAdmin } from "react-icons/gr";
import { FiShoppingBag } from "react-icons/fi";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { BsFillCalendar3EventFill } from "react-icons/bs";
import { useState } from "react";
import ProjectCard from "./ProjectCard";
import { Info } from "lucide-react";
export const ProjectsList = ({ projects }) => {
  const [filter, setFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");

  const isInactive = (updatedAt) => {
    if (!updatedAt) return true;
    const lastUpdated = new Date(updatedAt);
    const now = new Date();
    const diffInDays = (now - lastUpdated) / (1000 * 60 * 60 * 24);
    return diffInDays > 30;
  };

  const filteredProjects = projects.filter((project) => {
    const matchesFilter =
      filter === "all" ||
      (filter === "active" && !isInactive(project?.updatedAt)) ||
      (filter === "inactive" && isInactive(project?.updatedAt));

    const matchesSearch = project.project_name
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase());

    return matchesFilter && matchesSearch;
  });

  const activeCount = projects.filter(
    (project) => !isInactive(project.updatedAt)
  ).length;
  const inactiveCount = projects.filter((project) =>
    isInactive(project.updatedAt)
  ).length;

  // const activeCount = projects.filter(p => p.status === 'active').length;
  // const inactiveCount = projects.filter(p => p.status === 'inactive').length;

  return (
    <div className="border rounded-lg p-6">
      <div className="flex justify-between items-center mb-2">
        <div className="flex gap-2">
          <div className="relative">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.3-4.3"></path>
            </svg>
            <input
              type="text"
              placeholder="Search projects..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-9 pr-4 py-2 border rounded-md text-sm w-full md:w-64"
            />
          </div>
        </div>
      </div>
      <div className="flex items-center gap-1 bg-yellow-100 text-yellow-800 mb-2">
        <div className="flex h-4 w-8 items-center justify-center rounded-full">
          <Info className="h-4 w-4" />
        </div>
        <p className="text-xs pt-3">
          Projects are considered{" "}
          <span className="font-semibold">"Inactive"</span> if they haven't been
          updated in the last 30 days.
        </p>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
        <div className="flex border-b border-gray-200">
          <button
            onClick={() => setFilter("all")}
            className={`px-6 py-3 text-sm font-medium transition-colors duration-200 relative ${
              filter === "all"
                ? "text-blue-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            All Projects
            <span className="ml-2 px-2 py-0.5 text-xs rounded-full bg-gray-100 text-gray-600">
              {projects.length}
            </span>
            {filter === "all" && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600" />
            )}
          </button>
          <button
            onClick={() => setFilter("active")}
            className={`px-6 py-3 text-sm font-medium transition-colors duration-200 relative ${
              filter === "active"
                ? "text-blue-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            Active
            <span className="ml-2 px-2 py-0.5 text-xs rounded-full bg-green-100 text-green-600">
              {activeCount}
            </span>
            {filter === "active" && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600" />
            )}
          </button>
          <button
            onClick={() => setFilter("inactive")}
            className={`px-6 py-3 text-sm font-medium transition-colors duration-200 relative ${
              filter === "inactive"
                ? "text-blue-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            Inactive
            <span className="ml-2 px-2 py-0.5 text-xs rounded-full bg-yellow-100 text-yellow-600">
              {inactiveCount}
            </span>
            {filter === "inactive" && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600" />
            )}
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {filteredProjects.map((project, index) => (
          <ProjectCard key={index} project={project} />
        ))}
      </div>
    </div>
  );
};
